import { JobDto } from '@ivy-monorepo/shared'
import { apiClient } from './api-client'

class JobService {
  async getJobs(): Promise<JobDto[]> {
    const response = await apiClient.get('/admin/jobs')
    return response.data
  }
}

export const jobService = new JobService()
